export const ToggleOnIcon = props => (
  <span {...props}>
    <svg
      width="49"
      height="22"
      viewBox="0 0 49 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="49"
        height="22"
        rx="11"
        fill={props.fill ? props.fill : '#308CBF'}
      />
      <path
        d="M7.976 12.084L5.132 6.624H7.028L8.828 10.452L10.616 6.624H12.488L9.656 12.084V15H7.976V12.084ZM16.3129 9.624C15.5089 9.624 14.8729 10.14 14.7409 11.052H17.8969C17.8729 10.176 17.1769 9.624 16.3129 9.624ZM19.4689 12.912C19.1089 14.136 18.0049 15.108 16.3609 15.108C14.4289 15.108 13.0249 13.764 13.0249 11.676C13.0249 9.576 14.3929 8.244 16.3609 8.244C18.2809 8.244 19.6369 9.552 19.6369 11.532C19.6369 11.748 19.6249 11.964 19.5889 12.18H14.7289C14.8129 13.164 15.4849 13.716 16.3249 13.716C17.0449 13.716 17.4409 13.356 17.6569 12.912H19.4689ZM26.0232 13.104C26.0232 14.244 25.0272 15.108 23.4072 15.108C21.7392 15.108 20.5752 14.136 20.5032 12.9H22.1952C22.2552 13.404 22.7232 13.788 23.3952 13.788C24.0552 13.788 24.4152 13.488 24.4152 13.104C24.4152 11.916 20.6592 12.672 20.6592 10.236C20.6592 9.132 21.6432 8.244 23.2872 8.244C24.8952 8.244 25.8672 9.12 25.9632 10.44H24.3552C24.3072 9.924 23.8992 9.576 23.2392 9.576C22.6152 9.576 22.2912 9.828 22.2912 10.212C22.2912 11.424 25.9752 10.668 26.0232 13.104Z"
        fill="white"
      />
      <circle cx="39" cy="11" r="8" fill="white" />
    </svg>
  </span>
);
